export default {"src":"/_next/static/media/dot-icon.f97adc3e.svg","height":32,"width":34,"blurWidth":0,"blurHeight":0};